<template>
  <div class="flex flex-1 items-start gap-2 flex-nowrap">
    <button
      aria-controls="expand-filters"
      :aria-expanded="isOpen"
      data-testid="filter-icon"
      class="flex text-lg"
      @click="toggleModal"
    >
      <FilterIconWithText />
    </button>
    <div class="flex flex-wrap">
      <ais-current-refinements class="flex gap-2">
        <template v-slot="{ items }">
          <div v-for="item in sortedFilteredAttributes(items)" :key="item.attribute">
            <drop-down-refinement-filter v-if="!omitAttributes.includes(item.attribute)" :refinement="item" />
          </div>
        </template>
      </ais-current-refinements>
    </div>
    <div class="flex flex-grow">
      <ais-clear-refinements>
        <template v-slot="{ canRefine, refine, createURL }">
          <a :href="createURL()" @click.prevent="refine" v-if="canRefine">
            <label
              class="inline-flex items-center rounded-full text-sm font-normal gap-2 px-2 py-1 non-italic w-max bg-gray-300 border border-gray-300 text-badge-blue hover:bg-indigo-light hover:cursor-pointer capitalize"
            >
              Clear <close-icon />
            </label>
          </a>
        </template>
        <template v-slot:resetLabel>
          {{ "" }}
        </template>
      </ais-clear-refinements>
    </div>
  </div>
  <DrawerModal :is-open="isOpen" title="my students filter" @close="toggleModal" drawer-width-class="md:w-[463px]">
    <template #modal-content>
      <div class="flex flex-nowrap flex-col w-full px-[40px] pt-[24px] md:pb-[78px]">
        <my-students-filters />
      </div>
    </template>
    <template #modal-footer>
      <div class="flex w-full justify-between items-align px-[40px] gap-x-[32px]">
        <div>
          <ais-clear-refinements>
            <template v-slot="{ refine, createURL }">
              <button
                class="w-[176px] h-[40px] bg-white text-teal-900 uppercase"
                component="a"
                :href="createURL()"
                @click.prevent="refine"
              >
                Clear
              </button>
            </template>
            <template v-slot:resetLabel>
              {{ "" }}
            </template>
          </ais-clear-refinements>
        </div>
        <div>
          <button class="w-[176px] h-[40px] bg-teal-900 text-white uppercase" @click="toggleModal">Close</button>
        </div>
      </div>
    </template>
  </DrawerModal>
</template>
<script setup>
import { computed, ref } from "vue";

import { AisClearRefinements, AisCurrentRefinements } from "vue-instantsearch/vue3/es";
import DrawerModal from "@/components/modals/DrawerModal";
import { CloseIcon } from "@/components/shared/icons";
import { FilterIconWithText } from "@/components/svg-icons";
import { useRegisteredFacets } from "./composables/useRegisteredFacets";
import DropDownRefinementFilter from "./Filters/DropDownRefinementFilter.vue";
import MyStudentsFilters from "./MyStudentsFilters.vue";

defineProps({
  omitAttributes: {
    type: Array,
    default: [],
  },
});

const { currentFacets } = useRegisteredFacets();

const isOpen = ref(false);

const toggleModal = () => {
  isOpen.value = !isOpen.value;
};

const sortedFilteredAttributes = computed(() => (items) => {
  const sortedList = [];
  currentFacets.value.forEach((facet) => {
    const refinement = items.find((item) => item.attribute === facet.attribute);
    if (refinement && refinement.refinements.length > 0) {
      sortedList.push(refinement);
    }
  });
  return sortedList;
});
</script>
